import { reducer } from 'store/common';
import { isAdmin } from 'utils/user';
import ActionType from './actionType';

const initialState = {};

const setUser = (state, payload) => ({
  ...state,
  ...payload,
  isAdmin: isAdmin(payload)
});

const actionsMapping = {
  [ActionType.SET_USER]: setUser,
};

export const userReducer = (state, action) => reducer(actionsMapping, state || initialState, action);
